const footerList = [
  {
    title: "محصولات",
    items: [
      {
        name: "دیتاسنتر ابری",
        link: "/vpc",
        type: "router",
      },
      {
        name: "سرور ابری",
        link: "/vps",
        type: "router",
      },

      {
        name: "شبکه توزیع محتوا (CDN)",
        link: "/cdn",
        type: "router",
      },
      {
        name: " امنیت ابری",
        link: "/cloud-security",
        type: "router",
      },
      {
        name: "DNS ابری",
        link: "/dns",
        type: "router",
      },
      {
        name: "PAM ابری",
        link: "/pam",
        type: "router",
      },
      {
        name: "آبجکت استوریج",
        link: "/object-storage",
        type: "router",
      },
      {
        name: "فضای کاری امن",
        link: "/secure-workspace",
        type: "router",
      },
      {
        name: "SIEM",
        link: "/siem",
        type: "router",
      },
    ],
  },
  {
    title: "راهکارها",
    items: [
      {
        name: "مهاجرت ابری",
        link: "/migrate",
        type: "router",
      },
      {
        name: " ابر خصوصی",
        link: "/privatecloud",
        type: "router",
      },
      {
        name: "ابر ترکیبی",
        link: "/privatecloud",
        type: "router",
      },
      {
        name: "سرور اختصاصی",
        link: "/dedicated-server",
        type: "router",
      },
      {
        name: "کولوکیشن",
        link: "/colocation",
        type: "router",
      },
      {
        name: "ابر ایزوله",
        link: "/isolated-cloud",
        type: "router",
      },
      {
        name: "سرویس‌های مدیریت شده",
        link: "/devops",
        type: "router",
      },
      {
        name: "راهکارهای سازمانی",
        link: "/enterprise-solutions",
        type: "router",
      },
      {
        name: "راهکار بکاپ",
        link: "/backup-solutions",
        type: "router",
      },
      {
        name: "مرکز عملیات امنیت (SOC)",
        link: "/soc",
        type: "router",
      },
      {
        name: "کوبرنتیز سازمانی",
        link: "/kubernetes",
        type: "router",
      },
    ],
  },
  {
    title: "قیمت‌ها",
    items: [
      {
        name: "شیوه قیمت‌گذاری",
        link: "https://abalon.cloud/blog/sla/",
        type: "link",
      },
    ],
  },
  {
    title: "آبالون",
    items: [
      {
        name: "درباره آبالون",
        link: "/aboutus",
        type: "router",
      },
      {
        name: "راهنمای سرویس‌ها",
        link: "https://abalon.cloud/blog/help/",
        type: "link",
      },
      {
        name: "سطوح خدماتی (SLA)",
        link: "https://abalon.cloud/blog/sla/",
        type: "link",
      },
      {
        name: "شرایط استفاده از خدمات",
        link: "https://abalon.cloud/blog/sla/",
        type: "link",
      },
      {
        name: "سوالات متداول",
        link: "https://panel.abalon.cloud/faq",
        type: "link",
      },
    ],
  },
  {
    title: "ارتباطات",
    items: [
      {
        name: "تماس با ما",
        link: "/contactus",
        type: "router",
      },
      {
        name: "ثبت تیکت",
        link: "https://panel.abalon.cloud/support",
        type: "link",
      },
      {
        name: "مشاوره تخصصی",
        link: "1",
        type: "popup",
      },
      {
        name: "ارتباط با واحد فروش",
        link: "1",
        type: "popup",
      },
      {
        name: " وبلاگ",
        link: "https://abalon.cloud/blog/",
        type: "link",
      },
      // {
      //   name: "فرصت‌های شغلی",
      //   link: "https://careers.abalon.cloud",
      //   type: "link",
      // },
    ],
  },
];
const socials = [
  {
    name: "تلگرام آبالون",
    icon: "mdi-telegram",
    href: "https://t.me/Abalon_Cloud",
    img: "/telegram.svg",
    alt: "تلگرام آبالون",
    title: "تلگرام آبالون",
  },
  {
    name: "یوتیوب آبالون",
    icon: "mdi-youtube",
    href: "https://www.youtube.com/channel/UCqX1yrUoTImlfQy8zF2bLww",
    img: "/youtube.svg",
    alt: "یوتیوب آبالون",
    title: "یوتیوب آبالون",
  },
  {
    name: "لینکدین آبالون",
    icon: "mdi-linkedin",
    href: "https://www.linkedin.com/company/abalon-cloud/",
    img: "/linkedin.svg",
    alt: "لینکدین آبالون",
    title: "لینکدین آبالون",
  },
  {
    name: "اینستاگرام آبالون",
    icon: "mdi-instagram",
    href: "https://www.instagram.com/abalon_cloud?igsh=MTR5MTZhN3NrYjdjcA==",
    img: "/instagram.svg",
    alt: "اینستاگرام آبالون",
    title: "اینستاگرام آبالون",
  },
];

const contacts = [
  {
    text: "تهران - سهروردی شمالی - هویزه غربی - ﭘﻠﺎک ۹۲ ",
    icon: "/location.svg",
    href: "https://goo.gl/maps/tEuP4vR5xALSyPWd7",
    title: "موقعیت مکانی آبالون",
    alt: "موقعیت مکانی آبالون",
  },
  {
    text: " ﺗﻠﻔﻦ: ۴۹ ۰۷۸۱ ۹۱ ۰۲۱",
    icon: "/phone.svg",
    href: "tel:02191078149",
    title: "تماس با آبالون",
    alt: "تماس با آبالون",
  },
];
const certificates = [
  {
    name: "انجمن صنفی کسب‌وکارهای اینترنتی",
    icon: "mdi-telegram",
    href: "javascript:;",
    img: "/anjoman.svg",
    title: "انجمن صنفی کسب‌وکارهای اینترنتی",
  },
  {
    name: "معاونت توسعه شرکت‌های دانش‌بنیان",
    icon: "mdi-telegram",
    href: "javascript:;",
    img: "/daneshbonyan.svg",
    title: "معاونت توسعه شرکت‌های دانش‌بنیان",
  },
  {
    name: "نماد اعتماد الکترونیکی",
    icon: "mdi-telegram",
    href: "https://trustseal.enamad.ir/?id=571547&Code=4RYCPlgPiiExAI29TGkxD5IlodpLEA9w",
    img: "/enamad.svg",
    title: "نماد اعتماد الکترونیکی",
  },
  {
    name: "سازمان نظام صنفی رایانه ای استان تهران",
    icon: "mdi-telegram",
    href: "https://tehran.irannsr.org/trade_unit/2406750/swd_id/104366/%D8%A7%D8%B9%D8%B6%D8%A7%DB%8C-%D8%AD%D9%82%D9%88%D9%82%DB%8C-%D8%B1%D8%A7%D9%87%DA%A9%D8%A7%D8%B1-%D8%A2%DB%8C%D9%86%D8%AF%D9%87-%D8%B2%D9%85%DB%8C%D9%86.html",
    img: "/nezamsenfi.svg",
    title:
      "سازمان نظام صنفی رایانه ای استان تهران، اعضای حقوقی راهکار آینده زمین",
  },
  {
    name: "جایزه فاب، فناوری اطلاعات برتر",
    icon: "mdi-telegram",
    href: "javascript:;",
    img: "/fab.svg",
    title: "جایزه فاب، فناوری اطلاعات برتر",
  },
  {
    name: "جامعه آزاد رایانش ابری ایران",
    icon: "mdi-telegram",
    href: "javascript:;",
    img: "/occc.svg",
    title: "جامعه آزاد رایانش ابری ایران",
  },

  {
    name: "شبکه آزمایشگاهی فناوری‌های راهبردی",
    icon: "mdi-telegram",
    href: "javascript:;",
    img: "/riasatjomhoori.svg",
    title: "شبکه آزمایشگاهی فناوری‌های راهبردی",
  },
];

export default { footerList, socials, contacts, certificates };
